
    import { Options, Vue } from 'vue-class-component';
    import { mapState } from 'vuex';
    import { Project } from '@/models/Project';
    import { ExportStatusObject, PageStatus } from './models/Interfaces';
    import EmailProfileModal from '@/components/Modals/EmailModals/EmailProfileModal.vue';
    import SMSProfileModal from '@/components/Modals/SMSModals/SMSProfileModal.vue';
    import SmsTemplateModal from '@/components/Modals/SMSModals/TemplateModal.vue';
    import NewsletterModal from '@/components/Modals/EmailModals/TemplateModal.vue';
    import SendTestSms from '@/components/Modals/SMSModals/SendTestSms.vue';
    import SendTestEmail from '@/components/Modals/EmailModals/SendTestEmail.vue';
    import { api } from '@/services/Api';
    import swal from 'sweetalert2';
    import Q from 'q';
    import { generalStore } from '@/store';

    /* eslint-disable no-undef */
    require('@/assets/js/accessibility/accessibilityMenu.min.js');
    require('@/assets/js/accessibility/accessibility-en.js');
    require('@/assets/js/accessibility/accessibility-he.js');
    require('@/assets/js/accessibility/accessibility-ru.js');

    require('@/assets/js/accessibility/css/accessibilityMenu.css');

    @Options({
        computed: {
            ...mapState(['UserFullName', 'Pages', 'CurrentPageId', 'Lang', 'ExportJobs']),
        },
        components: {
            EmailProfileModal,
            SMSProfileModal,
            SmsTemplateModal,
            SendTestSms,
            SendTestEmail,
            NewsletterModal,
        },
    })
    export default class AppLayout extends Vue {
        protected readonly Lang!: string;
        public readonly ExportJobs!: ExportStatusObject[];
        public CurrentPageId!: string;
        public UserFullName!: string;
        public SearchText = '';
        public Pages!: Project[];
        public IsIframe = false;
        public IsMenuCollapsed = localStorage.getItem('IsMenuCollapsed') == 'true';
        public LanguageSelectingStarted = false;
        public BuildVersion?: number = generalStore.state.BuildVersion;

        get ContentPadding(): string {
            return (this.$route.meta?.padding as string) || '';
        }

        public mounted(): void {
            this.IsIframe = this.DetectIframe();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ($ as any).accessibility.setDefaults(($ as any).accessibility.language[this.Lang.split('-')?.[0]]);
        }

        public PageName(id: string): string {
            return this.Pages.find((p) => p.Id == id)?.Name ?? '';
        }
        public PageStatusClass(id: string): string {
            switch (this.Pages.find((p) => p.Id == id)?.Status) {
                case PageStatus.NotPublished:
                    return 'red';
                case PageStatus.Published:
                    return 'green';
                case PageStatus.OnConstruction:
                    return 'yellow';
            }
            return '';
        }

        onCreateSmsTemplate() {
            this.$vfm.hide('sms-template_modal');
        }
        onCreateNewsletter() {
            this.$vfm.hide('newsletter_modal');
        }
        public async onLogout(): Promise<void> {
            localStorage.removeItem('yslp_token');
            await api.LogOut();
            this.$router.push({ name: 'login' });
            window.location.reload();
        }

        private DetectIframe(): boolean {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }

        public ToggleMenu(toggle: boolean): void {
            if (toggle !== true && toggle !== false) {
                toggle = !this.IsMenuCollapsed;
            }
            this.IsMenuCollapsed = toggle;
            localStorage.setItem('IsMenuCollapsed', this.IsMenuCollapsed ? 'true' : 'false');
        }

        public deleteExportJobs(job: ExportStatusObject) {
            this.$store.dispatch('clearExportJob', job.Id);
        }
        async ChangeLang(lang: string): Promise<void> {
            swal.showLoading();
            const delayPromise = Q.delay(1000);
            await api.ChangeLanguage(lang);
            await delayPromise;
            window.location.reload();
        }
    }
